export function removeItem(item: any) {
  return window.localStorage.removeItem(item)
}
export function getItem(item: any) {
  return window.localStorage.getItem(item)
}
export function addItem(localStorageName: string, item: any) {
  return window.localStorage.setItem(localStorageName, item)
}
